/**
 * Enova Cart Empty Handler
 * Ensures empty cart state displays correctly when last item is removed
 */

(function() {
  'use strict';

  console.log('[Enova] Cart Empty Handler initialized');

  // Monitor cart changes
  function checkCartEmpty() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const isEmpty = cartDrawer.classList.contains('is-empty');
    
    if (isEmpty) {
      console.log('[Enova] Cart is empty, ensuring correct display');
      ensureEmptyCartDisplay();
    }
  }

  function ensureEmptyCartDisplay() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    console.log('[Enova] Forcing empty cart display');

    // Force drawer__inner layout
    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.style.cssText = `
        display: flex !important;
        flex-direction: column !important;
        justify-content: center !important;
        align-items: center !important;
        min-height: 100vh !important;
        padding: 0 !important;
      `;
    }

    // Force empty state visibility
    const drawerInnerEmpty = cartDrawer.querySelector('.drawer__inner-empty');
    if (drawerInnerEmpty) {
      drawerInnerEmpty.style.cssText = `
        display: flex !important;
        flex-direction: column !important;
        justify-content: center !important;
        align-items: center !important;
        width: 100% !important;
        height: 100% !important;
        min-height: 80vh !important;
        padding: 60px 20px !important;
        visibility: visible !important;
        opacity: 1 !important;
      `;
      console.log('[Enova] Empty cart container forced visible');
    }

    const cartWarnings = cartDrawer.querySelector('.cart-drawer__warnings');
    if (cartWarnings) {
      cartWarnings.style.cssText = `
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        text-align: center !important;
        padding: 40px 20px !important;
        width: 100% !important;
        visibility: visible !important;
        opacity: 1 !important;
      `;
      console.log('[Enova] Cart warnings forced visible');
    }

    const emptyContent = cartDrawer.querySelector('.cart-drawer__empty-content');
    if (emptyContent) {
      emptyContent.style.cssText = `
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        gap: 24px !important;
        width: 100% !important;
        visibility: visible !important;
        opacity: 1 !important;
      `;
    }

    // Force empty text visibility
    const emptyText = cartDrawer.querySelector('.cart__empty-text');
    if (emptyText) {
      emptyText.style.cssText = `
        display: block !important;
        font-size: 20px !important;
        font-weight: 500 !important;
        margin: 0 !important;
        color: #121212 !important;
        visibility: visible !important;
        opacity: 1 !important;
      `;
      console.log('[Enova] Empty text:', emptyText.textContent);
    }

    // Force button visibility
    const continueButton = cartDrawer.querySelector('.drawer__inner-empty .button');
    if (continueButton) {
      continueButton.style.cssText = `
        display: inline-block !important;
        padding: 14px 32px !important;
        background: #121212 !important;
        color: #fff !important;
        visibility: visible !important;
        opacity: 1 !important;
      `;
      console.log('[Enova] Continue button forced visible');
    }

    // Hide ALL cart content elements
    const elementsToHide = [
      'cart-drawer-items',
      '.cart-drawer-items',
      '.cart-items',
      '.cart-drawer__footer',
      '.drawer__footer',
      '.cart__ctas',
      '.cart__footer',
      '.totals',
      '.tax-note',
      '.drawer__header',
      '.enova-free-shipping-bar',
      '#enova-crosssell-carousel-injected'
    ];

    elementsToHide.forEach(selector => {
      const elements = cartDrawer.querySelectorAll(selector);
      elements.forEach(el => {
        el.style.cssText = `
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          height: 0 !important;
          overflow: hidden !important;
        `;
      });
    });

    console.log('[Enova] Empty cart display enforced');
  }

  // Observer to watch for cart changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.matches('cart-drawer')) {
          // Run immediately
          checkCartEmpty();
          // Run again after a delay to catch async updates
          setTimeout(checkCartEmpty, 50);
          setTimeout(checkCartEmpty, 200);
          setTimeout(checkCartEmpty, 500);
        }
      }
    });
  });

  // Start observing when DOM is ready
  function init() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Observe class changes on cart-drawer
      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
      
      // Also observe child changes (for dynamic content updates)
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner) {
        observer.observe(drawerInner, {
          childList: true,
          subtree: true,
          attributes: true
        });
      }
      
      // Check initial state immediately
      checkCartEmpty();
      
      // Also check after delays to catch async updates
      setTimeout(checkCartEmpty, 100);
      setTimeout(checkCartEmpty, 500);
      setTimeout(checkCartEmpty, 1000);
      
      console.log('[Enova] Cart empty handler observer started');
    } else {
      // Retry if cart drawer not found yet
      setTimeout(init, 500);
    }
  }

  // Listen for cart update events
  document.addEventListener('cart:updated', () => {
    console.log('[Enova] Cart updated event detected');
    setTimeout(checkCartEmpty, 100);
  });

  // Listen for Shopify section render events
  document.addEventListener('shopify:section:load', () => {
    console.log('[Enova] Section loaded event detected');
    setTimeout(checkCartEmpty, 100);
  });

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

